import URLSearchParams from '@ungap/url-search-params'

const urlParams = new URLSearchParams(window.location.search);

export const urlVars = {
    urlLocale: urlParams.get('locale'),
    urlEmail: urlParams.get('email')
};